import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import Button, { WhiteButton } from '../ui/Button';

interface DeleteLocalDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteLocal: React.FC<DeleteLocalDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmation de suppression</DialogTitle>
      <DialogContent>
        Êtes-vous sûr de vouloir supprimer ce local ?
      </DialogContent>
      <DialogActions>
        <WhiteButton onClick={onClose}>Annuler</WhiteButton>
        <Button onClick={onConfirm} color="error">
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteLocal;
